export default __webpack_public_path__ + "static/media/USN.0e15aaaf.svg";